import T from 'i18n-react';
import lodashGet from 'lodash/get';

export const findAssigneeInOxygenMappingById = (oxygenId, oxygenMapping) => {
  return (
    oxygenMapping.users[oxygenId] ||
    oxygenMapping.companies[oxygenId] ||
    oxygenMapping.roles[oxygenId]
  );
};

export const getEntityDisplayNameById = (
  oxygen,
  id,
  fallBackName = T.translate('activity_v2.formerUser')
) => {
  const entity = findAssigneeInOxygenMappingById(id, oxygen) || { name: fallBackName };
  return entity.name;
};

export const getUserNameDisplayNameWithCompany = (
  oxygen,
  userId,
  fallBackName = T.translate('userUndefined')
) => {
  const user = lodashGet(oxygen, `users[${userId}]`);

  if (user) {
    const userCompanyDisplayName = lodashGet(user, 'company.name');

    return userCompanyDisplayName ? `${user.name} (${userCompanyDisplayName})` : user.name;
  }

  return fallBackName;
};

const isUserActive = (user) =>
  !!((!user.projectStatus || user.projectStatus === 'active') && user.name);

export const buildActiveUsersArray = (users) => {
  // Don't break if using apps don't pass `projectStatus` as part of the user's data (keep old behaviour of showing all users in that case)
  // Filter users with no name - as current user have nothing to do with them.
  return Object.values(users).filter((user) => isUserActive(user));
};

export const parseUserObjectForCommentComponent = (user) => {
  return {
    ...user,
    avatar: user.profileImg50,
    hasAvatar: user.profileImg50 && !user.profileImg50.endsWith('user_X50.png'),
  };
};

export const getUserCompanyName = (user) => {
  return lodashGet(user, 'company.name', '');
};
